<template>
  <keep-alive>
    <div class="withdrawATM">
      <p style="padding:40px;color:red;width:800px" v-if="true">
        當前「自助提領」通道不穩定，正在進行技術排查，「普通提領」通道正常，請放心使<br />
        用；（當前交易狀態仍處於結算中的用戶可能會延緩到賬時間，如有疑問可咨詢客服）
      </p>
      <template v-else>
        <div class="WithdrawableAmount">
          <div>
            <span>可提領金額</span>
            <p v-if="comlanxinInfoLength" @click="jumpGuide">
              <span>提領指南</span
              ><i class="fps-icon fps-icon-warning-inline"></i>
            </p>
          </div>
          <div>
            <span class="amountD">NT$</span>
            <span v-if="accountInfo" class="amountD1">{{
              accountInfo.reward
            }}</span>
          </div>
          <a
            v-if="lanxinInfo && lanxinInfo.lastWithdraw"
            href="https://www.newebpay.com/"
            target="_black"
            >最近一次提領 NT${{ lanxinInfo.lastWithdraw }}，去藍新金流查看
            <i class="fps-icon fps-icon-arrow-right"></i
          ></a>
        </div>
        <el-form
          v-if="comlanxinInfoLength"
          :model="applyForm"
          :rules="rules"
          ref="applyForm"
        >
          <el-form-item label="提領金額" prop="amount" class="amount">
            <el-input
              v-model="applyForm.amount"
              autocomplete="off"
              placeholder=""
            ></el-input>
            <div class="AmountDes">
              <!-- <p>申請提領至撥款，時間需要7個工作天，請耐心等待。</p> -->
              <p>申請提領至撥款，時間需要2-6個工作天，請耐心等待。</p>
              <p>提現金額需大於等於NT. 3000， 單筆最高NT. 9999</p>
              <p>單日最高提領金額NT. 19999</p>
            </div>
          </el-form-item>
        </el-form>
        <div v-if="comlanxinInfoLength" class="input-wrap">
          <div class="input-title">提領到第三方金流帳戶</div>
          <div class="input-content">
            <div class="lanxin-info">
              <div class="text-con">
                <div class="text-wrap">
                  <div class="info-label">名稱</div>
                  <div class="info-value">{{ lanxinInfo.memberName }}</div>
                  <div class="info-label">帳號</div>
                  <div class="info-value">{{ lanxinInfo.loginAccount }}</div>
                  <div class="info-label">身份證</div>
                  <div class="info-value">{{ lanxinInfo.memberUnified }}</div>
                </div>
                <img src="~@/assets/image/icons/lanxinCN.png" />
                <img src="~@/assets/image/icons/lanxinEN.png" />
              </div>
              <div class="tip-wrap">
                <p>藍新金流是專業的金融服務平台，保障您的財產安全。</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="comlanxinInfoLength" class="reads">
          <div class="reads_s">
            <div
              class="circle-wrap"
              :class="selectRead && 'selected'"
              @click="changeIsKeepStatus"
            >
              <fps-icon v-if="selectRead" type="check" size="12" />
            </div>
            <div>
              我已閱讀並同意
              <span style="color: #0091FF;" @click.stop="open()">提領辦法</span>
            </div>
          </div>
          <span class="isRead" :class="{ activeKeep: !isReads }"
            >請閱讀並同意申請提領</span
          >
        </div>
        <div v-if="comlanxinInfoLength" class="footer">
          <button
            text="button"
            :disabled="!lanxinInfo || !selectRead"
            @click="withdrawSubmit('applyForm')"
          >
            <i v-if="isLoading" class="el-icon-loading"></i>
            <span v-else>確認提領</span>
          </button>
        </div>
        <div v-else class="WithdrawableCreate">
          <span>創建第三方金流帳戶，用於提領</span>
          <p>
            我們與值得信賴的第三方金流服務商「藍新金流」合作，為您提供自助提領的便利。
          </p>
          <div class="add-user">
            <img src="~@/assets/image/icons/lanxinCN.png" />
            <img src="~@/assets/image/icons/lanxinEN.png" />
            <button text="button" @click="addInfo">創建帳戶</button>
          </div>
        </div>
      </template>

      <el-dialog
        title="提領辦法"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        width="418px"
        class="dislogmethods"
      >
        <div class="divider_mthods"></div>
        <div>
          1.
          依據臺灣相關法律規定，申請提領的用戶提供相關所需文件以利nicee官方協助完成勞務報酬單填寫，首次進行提現流程時，會需要上傳您的身份證正反面，若資料上有任何問題，nicee官方將與您聯繫相關事宜。
        </div>
        <div>
          2.
          本人擔保所提交之所有資料確認為本人所有，若有任何事情，本人願意負擔法律責任。
        </div>
        <div>
          3. 申請提領後，個人資料及銀行帳戶將自動綁定，如需更改請向客服反映。
        </div>
      </el-dialog>
    </div>
  </keep-alive>
</template>

<script>
import { applyWithdraw } from '@/api';
import { uploadImageToS3 } from '@/api';
import { mapGetters } from 'vuex';
import bankList from './bank.js';
export default {
  name: 'withdrawATM',
  data() {
    const INFO_KEY = 'WITHDRAW_INFO_KEY';
    const applyFormStr = localStorage.getItem(INFO_KEY);
    let applyForm;
    if (applyFormStr) {
      applyForm = JSON.parse(applyFormStr);
      // if (applyForm.bankName === '00000 Paypal') {
      //   applyForm.bankName = ''
      //   applyForm.branchName = ''
      //   applyForm.accountNo = ''
      // }
    } else {
      applyForm = {
        accountNo: '',
        accountUserName: '',
        bankName: '',
        branchName: '',
        Identity: '',
        Permanent: ''
      };
    }
    const showPaypal = applyForm.bankName === '00000 Paypal';
    return {
      errorMsg: '',
      selectRead: false,
      INFO_KEY,
      bankList: bankList,
      isLoading: false,
      bankbookExisturl: require('@/assets/images/bankbook.png'),
      bankbookExisturlArr: [require('@/assets/images/bankbook.png')],
      dialogVisible: false,
      isKeepStatus: false,
      dialogFormVisible: false,
      isImageUrl_P: false,
      isImageUrl_B: false,
      imageUrl_b: '',
      imageUrl_p: '',
      dialogImageUrlP: true,
      dialogImageUrlB: true,
      identityBackImg: '',
      bankbookImg: '',
      identityFrontImg: '',
      isImageUrl_O: false,
      imageUrl_o: '',
      dialogImageUrlO: true,
      currencyKind: '',
      isNormal: '',
      isReads: false,
      test: '',
      visible: false,
      applyForm,
      showPaypal
    };
  },
  computed: {
    ...mapGetters(['accountInfo']),
    rules() {
      const {
        isAccountNo,
        isAccountUserName,
        isEmail,
        isAccount,
        isPaypalName,
        isBranchName,
        isIdentity,
        isPermanent,
        showPaypal,
        donotNeed
      } = this;
      let rs = {
        accountNo: [
          {
            required: true,
            message: showPaypal
              ? '請正確填寫您的Paypal電子郵箱'
              : '請正確填寫您的帳戶號碼（只允許數字，10-14位之間）',
            trigger: 'blur'
          },
          { validator: showPaypal ? isEmail : isAccountNo, trigger: 'blur' }
        ],
        accountUserName: [
          {
            required: true,
            message: '身份證姓名需與銀行資料開戶名相同',
            trigger: 'blur'
          },
          { validator: isAccountUserName, trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '請輸入提現金額', trigger: 'blur' },
          { validator: isAccount, trigger: 'blur' }
        ],
        bankName: [
          {
            required: true,
            message: '請選擇您的銀行名稱与代码',
            trigger: 'blur'
          }
        ],
        // {validator: isBankName, trigger: 'blur'},
        branchName: [
          {
            required: true,
            message: showPaypal
              ? '請正確填寫您的Paypal用戶名'
              : '請正確填寫您的分行名稱（上限20個字符）',
            trigger: 'blur'
          },
          {
            validator: showPaypal ? isPaypalName : isBranchName,
            trigger: 'blur'
          }
        ],
        Permanent: [
          {
            required: true,
            message: '請正確填寫您的戶籍地址',
            trigger: 'blur'
          },
          { validator: isPermanent, trigger: 'blur' }
        ],
        Identity: [
          {
            required: true,
            message: '請正確填寫您的身份證字號',
            trigger: 'blur'
          },
          { validator: showPaypal ? donotNeed : isIdentity, trigger: 'blur' }
        ]
      };
      return rs;
    },
    comlanxinInfoLength() {
      if (!this.lanxinInfo) return false;
      return Object.keys(this.lanxinInfo).length > 1;
    }
  },
  watch: {
    isKeepStatus(flag) {
      if (flag) {
        this.isReads = false;
      } else {
        this.isReads = true;
      }
    }
  },
  created() {
    this.WithdrawalBenefit();
  },
  methods: {
    jumpGuide() {
      let routeUrl = this.$router.resolve({
        path: '/withdraw-guide'
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push('/withdraw-guide')
    },
    addInfo() {
      window.sessionStorage.setItem('LAST_INPNT_PRICE', this.price);
      this.$router.push({
        name: 'WithdrawInfo'
      });
    },
    isEmail(rule, value, callback) {
      let regEn = /^(\w+\.)*\w+@\w+(.\w+)+$/;
      if (regEn.test(value)) {
        callback();
      } else {
        callback(new Error('電子郵箱不符合規則'));
      }
    },
    donotNeed(rule, value, callback) {
      callback();
    },
    isPaypalName(rule, value, callback) {
      if (value.length > 20) {
        callback(new Error('請輸入1-20位字符'));
      }
      callback();
    },
    isAccount(rule, value, callback) {
      let isNormal = this.$route.query.isNormal;
      //輸入的數字可以是整數，可以是小數，但是不能超過2位小數
      let regEn = /^\d{1,4}$/;
      if (isNormal === 'Invitation') {
        if (value > 9999) {
          callback('單次提領不能超過9999');
        } else if (!regEn.test(value)) {
          callback(new Error('請輸入整數'));
        } else if (value > this.accountInfo.reward) {
          callback(new Error('餘額不足'));
        } else if (value == 0) {
          callback(new Error('提取金額不能為0'));
        } else if (value < 3000) {
          callback(new Error('每次提領金額不能小於NT$3000'));
        }
      } else {
        if (value > 9999) {
          callback('單次提領不能超過9999');
        } else if (!regEn.test(value)) {
          callback(new Error('請輸入整數'));
        } else if (value > this.accountInfo.reward) {
          callback(new Error('餘額不足'));
        } else if (value == 0) {
          callback(new Error('提取金額不能為0'));
        } else if (value < 3000) {
          callback(new Error('每次提領金額不能小於NT$3000'));
        }
      }
      callback();
    },
    isAccountNo(rule, value, callback) {
      let regEn = /^\d{10,14}$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入10~14位数字'));
      }
      callback();
    },
    isAccountUserName(rule, value, callback) {
      let regEn = /^[\u4e00-\u9fa5]{2,10}$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入2-10位漢字'));
      }
      callback();
    },
    isBranchName(rule, value, callback) {
      let regEn = /^[\u4e00-\u9fa5]{2,20}$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入2-20位漢字'));
      }
      callback();
    },
    isIdentity(rule, value, callback) {
      let regEn = /^[^\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b]{10,14}$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入10-14位正確的身份證字號'));
      }
      callback();
    },
    isPermanent(rule, value, callback) {
      let regEn = /^([^\x00-\xff]|[A-Za-z0-9_])+$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入正確的戶籍地址'));
      }
      callback();
    },
    /**
     * @description 當銀行信息改變，其他信息跟著改變
     */
    bankNameChange(bankName) {
      if (bankName === '00000 Paypal') {
        this.showPaypal = true;
      } else {
        this.showPaypal = false;
      }
    },
    /**
     * @description 是否记住選擇状态
     */
    changeIsKeepStatus() {
      this.isKeepStatus = !this.isKeepStatus;
      this.selectRead = !this.selectRead;
    },
    WithdrawalBenefit() {
      this.currencyKind = 'TWD';
      // var params = {
      //   "accountKind":["Reward"]
      // };
      //數據回顯
      // getWithdrawHistory(params).then(data=>{
      //   if(data.data.length != 0){
      //     this.applyForm= data.data;
      //     this.identityBackImg = data.data.identityBackImg;
      //     this.identityFrontImg = data.data.identityFrontImg;
      //     this.bankbookImg = data.data.bankbookImg
      //   }else{
      //     return false;
      //   }
      // })
    },
    // 驗證身份證圖片
    handleAvatarSuccessP({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd).then(({ data }) => {
        this.identityFrontImg = data;
        this.imageUrl_p = data;
        this.isImageUrl_P = true;
        this.dialogImageUrlP = true;
      });
      // this.imageUrl_p = URL.createObjectURL(file.raw);
      // this.identityFrontImg = res.data;
      // this.isImageUrl_P = true;
      // this.dialogImageUrlP = true;
    },
    // 驗證身份證圖片
    handleAvatarSuccessO({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd).then(({ data }) => {
        this.identityBackImg = data;
        this.imageUrl_o = data;
        this.isImageUrl_O = true;
        this.dialogImageUrlO = true;
      });
      // this.imageUrl_o = URL.createObjectURL(file.raw);
      // this.identityBackImg=res.data;
      // this.isImageUrl_O = true;
      // this.dialogImageUrlO = true;
    },
    // 驗證銀行存摺圖
    handleBankbookSuccess({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd).then(({ data }) => {
        this.bankbookImg = data;
        this.imageUrl_b = data;
        this.isImageUrl_B = true;
        this.dialogImageUrlB = true;
      });
      // this.imageUrl_o = URL.createObjectURL(file.raw);
      // this.identityBackImg=res.data;
      // this.isImageUrl_O = true;
      // this.dialogImageUrlO = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/JPEG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 3MB!');
      }
      return isJPG && isLt2M;
    },
    saveInfo(obj) {
      const { INFO_KEY } = this;
      obj
        ? localStorage.setItem(INFO_KEY, JSON.stringify(obj))
        : localStorage.removeItem(INFO_KEY);
    },
    withdrawSubmit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.$confirm({
            content: '點擊「確認提領」，即確認將輸入的金額提領至藍新金流帳戶。',
            title: '確認提領嗎？',
            confirmButtonText: '確認提領',
            cancelButtonText: '再想想'
          })
            .then(() => {
              if (this.isLoading) return;
              this.isLoading = true;
              this.$http
                .post('/withdraw/lanxin/withdraw', {
                  accountKind: 'Reward',
                  currencyKind: 'TWD',
                  amount: this.applyForm.amount
                })
                .then(() => {
                  window.sessionStorage.setItem(
                    'LAST_INPNT_PRICE',
                    this.applyForm.amount
                  );
                  this.$emit('handleFinsh', true);
                  this.isLoading = false;
                  this.$store.dispatch('app/getUserAccount');
                })
                .catch(() => {
                  this.isLoading = false;
                });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    submitForm(formName) {
      if (this.isLoading) return;
      if (!this.isImageUrl_P) {
        this.dialogImageUrlP = false;
        return;
      } else if (!this.isImageUrl_O) {
        this.dialogImageUrlO = false;
        return;
      } else if (!this.showPaypal && !this.isImageUrl_B) {
        this.dialogImageUrlB = false;
        return;
      } else {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            let isNormal = this.$route.query.isNormal;
            var params;
            if (isNormal === 'Invitation') {
              params = {
                accountKind: 'Cash', //個人帳戶reward   激勵帳戶Cash 要根據不同情況實時改變字段
                accountNo: this.applyForm.accountNo, //帳戶號碼
                accountUserName: this.applyForm.accountUserName, //真實姓名
                amount: this.applyForm.amount, //提現金額
                bankName: this.applyForm.bankName, //銀行名稱
                branchName: this.applyForm.branchName, //銀行分行名稱
                currencyKind: this.currencyKind, //貨幣類型
                identityBackImg: this.identityBackImg, //身份證反面
                bankbookImg: this.bankbookImg,
                identityFrontImg: this.identityFrontImg, //身份證正面
                identityNo: this.applyForm.Identity, //身份證號
                address: this.applyForm.Permanent, //戶籍地址
                withdrawKind: 'Normal'
              };
            } else {
              params = {
                accountKind: 'Reward', //個人帳戶reward   激勵帳戶Cash 要根據不同情況實時改變字段
                accountNo: this.applyForm.accountNo, //帳戶號碼
                accountUserName: this.applyForm.accountUserName, //真實姓名
                amount: this.applyForm.amount, //提現金額
                bankName: this.applyForm.bankName, //銀行名稱
                branchName: this.applyForm.branchName, //銀行分行名稱
                currencyKind: this.currencyKind, //貨幣類型
                identityBackImg: this.identityBackImg, //身份證反面
                bankbookImg: this.bankbookImg, //身份證反面
                identityFrontImg: this.identityFrontImg, //身份證正面
                identityNo: this.applyForm.Identity, //身份證號
                address: this.applyForm.Permanent, //戶籍地址
                withdrawKind: 'Normal'
              };
            }

            if (this.isKeepStatus) {
              //ajax
              try {
                await this.$confirm({
                  content: '是否保存最新提領信息',
                  confirmButtonText: '確認',
                  cancelButtonText: '否',
                  closeOnClickModal: false,
                  closeOnPressEscape: false
                });
                const {
                  accountNo,
                  accountUserName,
                  bankName,
                  branchName,
                  Identity,
                  Permanent
                } = this.applyForm;
                this.saveInfo({
                  accountNo,
                  accountUserName,
                  bankName,
                  branchName,
                  Identity,
                  Permanent
                });
              } catch (e) {
                this.saveInfo();
              }
              this.isLoading = true;
              applyWithdraw(params)
                .then(res => {
                  if (res.code == 200) {
                    this.$message.success('提交成功');
                    this.$router.go(-1);
                  }
                  this.isLoading = false;
                })
                .catch(() => {
                  this.isLoading = false;
                });
            } else {
              this.isReads = true;
            }
          } else {
            return false;
          }
        });
      }
    },
    open() {
      this.dialogVisible = true;
    }
  },
  props: {
    price: {
      type: String,
      default: () => {
        return '';
      }
    },
    lanxinInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.WithdrawableAmount {
  margin-left: 40px;
  margin-top: 32px;
  margin-bottom: 42px;
  > div:nth-of-type(1) {
    > span {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: $color-gray-1;
    }
    > p {
      cursor: pointer;
      margin-left: 292px;
      span {
        font-size: 14px;
        line-height: 18px;
        text-align: right;
        letter-spacing: 0.02em;
        color: #007aff;
      }
      i {
        color: #007aff;
        margin-left: 3.78px;
        &:before {
          transform: rotate(180deg);
          display: inline-block;
        }
      }
    }
  }
  > div:nth-of-type(2) {
    margin-top: 6px;
    .amountD1 {
      margin-left: 12px;
    }
  }
  > div {
    display: flex;
  }
  > a {
    display: block;
    margin-top: 8px;
    font-size: 14px;
    line-height: 18px;
    color: #636d86;
    cursor: pointer;
    i {
      font-size: 13px;
    }
  }
  .amountD,
  .amountD1 {
    font-weight: 600;
    font-size: 22px;
    line-height: 26px;
    color: $color-orange;
  }
}
.input-wrap {
  margin-top: 14px;
  margin-left: 40px;
  .input-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    text-align: left;
  }
  .input-content {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    .money-error {
      position: absolute;
      top: 54px;
      left: 0;
      font-size: 14px;
      line-height: 20px;
      color: #ff0d0d;
    }
    input {
      width: 434px;
      height: 48px;
      padding: 14px 10px;
      background: $color-light;
      border: 1px solid $color-split;
      box-sizing: border-box;
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      caret-color: $color-link;
      &::placeholder {
        color: #cacaca;
      }
    }
    .tip-wrap {
      width: 371px;
      margin-left: 20px;
    }
    p {
      font-size: 13px;
      line-height: 18px;
      color: $color-gray-2;
    }
  }
  .lanxin-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    .text-con {
      padding: 6px 12px;
      width: 434px;
      background: $color-light;
      border: 1px solid $color-split;
      box-sizing: border-box;
      border-radius: 4px;
      font-size: 13px;
      line-height: 26px;
      color: $color-gray-2;
      display: flex;
      img {
        margin-top: 10px;
      }
      img:nth-of-type(1) {
        width: 59.31px;
        height: 16.25px;
      }
      img:nth-of-type(2) {
        width: 60.94px;
        height: 14.62px;
      }
    }
    .text-wrap {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      .info-label {
        width: 60px;
      }
      .info-value {
        width: 200px;
      }
    }
    .tip-wrap {
      width: 371px;
    }
  }
}
.add-user {
  margin-top: 16px;
  padding: 6px 12px;
  width: 434px;
  background: $color-light;
  border: 1px solid $color-split;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 13px;
  line-height: 26px;
  color: $color-gray-2;
  display: flex;
  align-items: center;
  img:nth-of-type(1) {
    width: 73.72px;
    height: 20.2px;
  }
  img:nth-of-type(2) {
    width: 75.74px;
    height: 18.18px;
    margin-left: -7px;
  }
  button {
    margin-left: 143.6px;
    width: 168px;
    height: 48px;
    border-radius: 50px;
    background: $color-yellow;
    font-weight: 500;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    letter-spacing: -0.000319808px;
    color: $color-gray-1;
  }
}
.withdrawATM {
  margin: 0 auto;
  padding-bottom: 60px;
  margin-bottom: 100px;
  background: #ffffff;
  .el-dialog__wrapper {
    & /deep/ .el-dialog {
      border-radius: 8px;
    }
    & /deep/ .el-dialog__body {
      padding: 0;
      padding-bottom: 60px;
      // padding: 0 30px 60px 30px;
      .divider_mthods {
        width: 100%;
        height: 1px;
        background: #ececec;
      }
      div {
        font-size: 14px;
        color: #333333;
        padding: 0 30px 0 30px;
        line-height: 20px;
        margin-bottom: 20px;
      }
    }
  }
  .footer {
    width: 142px;
    height: 46px;
    border-radius: 4px;
    text-align: center;
    margin-left: 40px;
    button {
      margin-top: 20px;
      width: 168px;
      height: 48px;
      border-radius: 50px;
      background: $color-yellow;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: $color-gray-1;
      &:disabled {
        background: $color-button !important;
        font-weight: 500;
        font-size: 16px;
        color: rgba(99, 109, 134, 0.3) !important;
      }
    }
  }
  .reads {
    width: 191px;
    margin-left: 40px;
    margin-top: 51px;
    text-align: left;
    overflow: hidden;
    .reads_s {
      cursor: pointer;
      display: flex;
      div {
        vertical-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        span {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .circle-wrap {
      width: 16px;
      height: 16px;
      border: 1px solid #8c94aa;
      box-sizing: border-box;
      box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      margin-right: 8px;
      cursor: pointer;
      &.selected {
        border: none;
        background: $color-yellow;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .isRead {
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: #fd2243;
      margin-left: 24px;
    }
    .activeKeep {
      opacity: 0;
    }
  }
  & /deep/ .el-form {
    padding: 0 40px;
    overflow: hidden;
    .PersonalData {
      overflow: hidden;
      .UploadIDCard {
        width: 505px;
        @include flex(center, top);
        .IDCard_dec {
          width: 200px;
          margin-top: 25px;
          p {
            width: 200px;
            font-size: 12px;
            margin-bottom: 5px;
            color: #999999;
          }
        }
        .UploadIDCard_Positive {
          height: 127px;
          margin-left: 6px;
          .el-upload__text {
            margin-top: 5px;
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            color: #fd2243;
          }
          .Positive_title {
            font-weight: 500;
            font-size: 14px;
            color: #666666;
          }
          .avatar-uploader {
            width: 124px;
            height: 72px;
            display: block;
            margin-top: 5px;
            .avatar-uploader-icon {
              font-size: 14px;
              color: #fa006e;
              width: 124px;
              height: 72px;
              line-height: 72px;
              text-align: center;
            }
            .avatar {
              width: 124px;
              height: 72px;
              border-radius: 4px;
              display: block;
            }
            .el-upload {
              border: 1px solid #fa006e;
              border-radius: 4px;
              cursor: pointer;
            }
          }
        }
        .UploadIDCard_Verso {
          margin: 0 30px;
          height: 127px;
          .el-upload__text {
            margin-top: 5px;
            font-weight: 500;
            font-size: 12px;
            color: #fd2243;
            line-height: 17px;
          }
          .Verso_title {
            font-weight: 500;
            font-size: 14px;
            color: #666666;
          }
          .avatar-uploader {
            width: 124px;
            height: 72px;
            display: block;
            margin-top: 5px;
            .avatar-uploader-icon {
              font-size: 14px;
              color: #fa006e;
              width: 124px;
              height: 72px;
              line-height: 72px;
              text-align: center;
            }
            .avatar {
              width: 124px;
              height: 72px;
              border-radius: 4px;
              display: block;
            }
            .el-upload {
              border: 1px solid #fa006e;
              border-radius: 4px;
              cursor: pointer;
            }
          }
        }
      }
      .el-form-item {
        float: left;
        margin-right: 30px;
      }
      .PersonalData_title {
        margin-bottom: 25px;
        img {
          width: 25px;
          height: 25px;
          vertical-align: middle;
          margin-right: 7px;
        }
        span {
          font-weight: 600;
          font-size: 16px;
          color: #333333;
          vertical-align: middle;
        }
      }
    }
    .BankInformation {
      overflow: hidden;
      .el-form-item {
        float: left;
        margin-right: 30px;
      }
      .uploadBankbook {
        width: 600px;
        align-items: center;
        @include flex(flex-start, top);
        .show-exist {
          margin: 0 13px 0 0px;
          font-style: normal;
          font-weight: 500;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #666666;
        }
        .show-exist-img {
          width: 119px;
          height: 74px;
          position: relative;
          bottom: 3px;
          margin-right: 32px;
        }
        .IDCard_dec {
          width: 200px;
          height: 74px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          p {
            width: 200px;
            font-size: 12px;
            margin-bottom: 5px;
            color: #999999;
          }
        }
        .bankbook {
          height: 127px;
          .el-upload__text {
            margin-top: 5px;
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            color: #fd2243;
          }
          .bankbook_title {
            font-weight: 500;
            font-size: 14px;
            color: #666666;
          }
          .bankbook-uploader {
            width: 158px;
            height: 72px;
            display: block;
            margin-top: 5px;
            .bankbook-uploader-icon {
              font-size: 14px;
              color: #fa006e;
              width: 124px;
              height: 72px;
              line-height: 72px;
              text-align: center;
            }
            .bankbook {
              width: 124px;
              height: 72px;
              border-radius: 4px;
              display: block;
            }
            .el-upload {
              border: 1px solid #fa006e;
              border-radius: 4px;
              cursor: pointer;
            }
          }
        }
      }
      .BankInformation_title {
        margin-bottom: 25px;
        img {
          width: 25px;
          height: 25px;
          vertical-align: middle;
          margin-right: 7px;
        }
        span {
          font-weight: 600;
          font-size: 16px;
          color: #333333;
          vertical-align: middle;
        }
      }
    }
    .amount {
      position: relative;
      height: 108px;
      & /deep/ .el-form-item__content {
        line-height: 20px;
      }
      .AmountDes {
        position: absolute;
        left: 455px;
        top: 25px;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        color: #636d86;
      }
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #222c43;
      padding-bottom: 5px;
      &::before {
        content: '';
      }
    }
    .el-form-item__content {
      .el-form-item__error {
        font-weight: 500;
        font-size: 12px;
        color: #fd2243;
      }
      .el-input {
        .el-input__inner {
          width: 434px;
          background: #f9f9f9;
          border-radius: 4px;
          &::placeholder {
            font-size: 14px;
          }
          &:focus {
            background: #ffffff;
            box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
          }
        }
      }
      el-select {
        width: 434px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 4px;
      }
    }
  }
  el-select {
    width: 434px;
    height: 40px;
    background: #f9f9f9;
    border-radius: 4px;
  }

  .applydrawable {
    margin-left: 40px;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
  }
  .divider {
    width: 1200px;
    height: 2px;
    background: #f4f4f4;
    margin-top: 20px;
  }
  .WithdrawableCreate {
    margin-left: 40px;
    margin-top: 32px;
    margin-bottom: 42px;
    > span {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #222c43;
      margin-right: 12px;
    }
    > p {
      font-size: 14px;
      line-height: 18px;
      color: #636d86;
      width: 434px;
      margin-top: 4px;
    }
  }
}
</style>
